var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_9585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61475 26.5501C8.61475 22.8149 11.6415 19.7832 15.3817 19.7832C19.1168 19.7832 22.1486 22.81 22.1486 26.5501H8.6197H8.61475Z",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3845 19.789C17.5377 19.789 19.2831 18.0435 19.2831 15.8903C19.2831 13.7372 17.5377 11.9917 15.3845 11.9917C13.2313 11.9917 11.4858 13.7372 11.4858 15.8903C11.4858 18.0435 13.2313 19.789 15.3845 19.789Z",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 11.2137C11.5884 10.0347 13.3371 9.31641 15.2543 9.31641C17.1615 9.31641 18.9052 10.0248 20.2328 11.1939",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.638 9.06696C18.6717 8.30336 19.7013 6.03571 18.9377 4.00203C18.1741 1.96834 15.9064 0.938736 13.8727 1.70234C11.8391 2.46594 10.8095 4.73359 11.5731 6.76727C12.3367 8.80096 14.6043 9.83056 16.638 9.06696Z",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1431 19.9221C21.1388 19.0205 22.4615 18.4756 23.908 18.4756C27.014 18.4756 29.5305 20.9921 29.5305 24.0982H23.3086",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1471 15.231C27.1471 17.0193 25.6956 18.4708 23.9073 18.4708C22.1189 18.4708 20.6675 17.0193 20.6675 15.231C20.6675 13.4427 22.1189 11.9912 23.9073 11.9912C25.6956 11.9912 27.1471 13.4427 27.1471 15.231Z",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5628 19.9221C9.56705 19.0205 8.24438 18.4756 6.79787 18.4756C3.69183 18.4756 1.17529 20.9921 1.17529 24.0982H7.39728",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55127 15.2315C3.55127 17.0198 5.00274 18.4713 6.79106 18.4713C8.57939 18.4713 10.0309 17.0198 10.0309 15.2315C10.0309 13.4432 8.57939 11.9917 6.79106 11.9917C5.00274 11.9917 3.55127 13.4432 3.55127 15.2315Z",
    stroke: "#0D4248",
    strokeWidth: 0.782928,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_9585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3513,
    height: 26.0917,
    fill: "white",
    transform: "translate(0.674316 0.954102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon4);
export default __webpack_public_path__ + "static/media/benefit-icon4.62ac78da879907e9838560e4b2fb6f4a.svg";
export { ForwardRef as ReactComponent };